import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
	LWApiPublicNotificationResolveParamsRawI,
	LWApiPublicNotificationResolveResultRawI,
} from '@liquidweb-dev/club-sauce/public/notifications/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';
import { NOTIFICATIONS_CURRENT_QUERY_KEY } from 'modules/queries/notification/useCurrent';
import useSnackbarError from 'utility/hooks/useSnackbarError';

const useNotificationResolve = () => {
	const queryClient = useQueryClient();
	const snackbarError = useSnackbarError();

	return useMutation<
		LWApiPublicNotificationResolveResultRawI,
		ApiErrorI,
		LWApiPublicNotificationResolveParamsRawI
	>({
		mutationFn: (params) => api.notifications.apiRaw.resolve(params),

		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [NOTIFICATIONS_CURRENT_QUERY_KEY],
			});
		},

		onError: snackbarError,
	});
};

export default useNotificationResolve;
